import { startOfDay } from "date-fns";

export const today = startOfDay(new Date()).toISOString();

export function convertTo12HrTime(time24 = ""): string {
  if (!time24) return "";
  const [hours, minutes] = time24.split(":");
  const hour = parseInt(hours, 10);
  const period = hour >= 12 ? "pm" : "am";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes}${period}`;
}

/**
 * Formats a month number to ensure it's always a two-digit string
 * @param month - The month as a number (1-12) or string ("1" or "01")
 * @returns A two-digit string representation of the month ("01", "02", etc.)
 */
export function formatMonthTwoDigits(
  month: number | string
): string | undefined {
  if (typeof month !== "number" && typeof month !== "string") {
    return undefined;
  }
  const monthNumber = typeof month === "string" ? parseInt(month, 10) : month;
  return monthNumber.toString().padStart(2, "0");
}
